import React from 'react';
import { useBehandelingenIntro } from '../hooks/useBehandelingenIntro';

interface BehandelingenIntroProps {
  // Props can be extended in the future if needed
}

const BehandelingenIntro: React.FC<BehandelingenIntroProps> = () => {
  const { data, loading, error } = useBehandelingenIntro();

  // Debug logging for behandelingen intro data
  if (data && !loading && !error) {
    console.log('🎯 BehandelingenIntro - ✅ Strapi data loaded:', !!data);
    console.log('🎯 BehandelingenIntro - Data keys:', Object.keys(data || {}));
    console.log('🎯 BehandelingenIntro - Text:', data.text);
    console.log('🎯 BehandelingenIntro - Background color:', data.backgroundColor);
  }

  // Default fallback data
  const defaultData = {
    text: 'Geen standaardmiddeltjes, maar een persoonlijke, medisch onderbouwde aanpak voor haarverlies op hoofd, baard, snor of wenkbrauwen.',
    backgroundColor: '#F6F7F9'
  };

  const sectionData = data || defaultData;
  const backgroundColor = data?.backgroundColor || defaultData.backgroundColor;

  if (loading) {
    return (
      <section 
        className="behandelingen-intro-section section-padding"
        style={{ backgroundColor: defaultData.backgroundColor }}
      >
        <div className="container">
          <div className="behandelingen-intro-content">
            <div className="loading-placeholder">
              <div className="loading-text"></div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section 
        className="behandelingen-intro-section section-padding"
        style={{ backgroundColor: defaultData.backgroundColor }}
      >
        <div className="container">
          <div className="behandelingen-intro-content">
            <p className="behandelingen-intro-text">
              {defaultData.text}
            </p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section 
      className="behandelingen-intro-section section-padding"
      style={{ backgroundColor }}
    >
      <div className="container">
        <div className="behandelingen-intro-content">
          <p className="behandelingen-intro-text">
            {sectionData.text}
          </p>
        </div>
      </div>
    </section>
  );
};

export default BehandelingenIntro;